/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {create} from 'zustand';

export type AppState = {
  returnTo: string | null;
  hasRunRedirectCallback: boolean;
};

interface Auth0Store {
  returnTo: string | null;
  hasRunRedirectCallback: boolean;
  setAuthState: (newState: AppState) => void;
}

export const useAuth0Store = create<Auth0Store>((set) => ({
  returnTo: null,
  hasRunRedirectCallback: false,
  setAuthState: (newState) =>
    set(() => ({
      returnTo: newState.returnTo,
      hasRunRedirectCallback: newState.hasRunRedirectCallback,
    })),
}));
